export const SET_SAVING_FILE = 'SET_SAVING_FILE';
export const SET_CONTRACTS_ERROR = 'SET_CONTRACTS_ERROR';
export const SET_DOC_INFO = 'SET_DOC_INFO';
export const SET_DOC_FETCHING = 'SET_DOC_FETCHING';
